import { ComboboxController } from '@avanta/shared/components/Combobox';
import { Input } from '@avanta/shared/components/ui/Input';
import { SelectController } from '@avanta/shared/components/ui/Select';
import { ADMIN_ROLES } from '@avanta/shared/constants/admins';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { EMAIL_PATTERN } from '@avanta/shared/constants/patterns';
import { type InputForm } from 'types/form';

export type AddAdministratorForm = {
  name: string;
  surname: string;
  email: string;
  role: string;
  contractIds: string[];
};

const roleOptions = Object.values(ADMIN_ROLES).map(role => ({
  label: `AdministratorsPage.Table.role.options.${role}`,
  value: role,
  description: `AdministratorsPage.Table.role.description.${role}`,
  ns: LOCIZE_NS.INSURANCE,
}));

export const addAdministratorForm: Record<keyof AddAdministratorForm, InputForm> = {
  name: {
    label: 'AdministratorsPage.Form.name.label',
    name: 'name',
    type: 'text',
    placeholder: 'insurance:AdministratorsPage.Form.name.placeholder',
    required: true,
    component: Input,
  },
  surname: {
    label: 'AdministratorsPage.Form.surname.label',
    name: 'surname',
    type: 'text',
    placeholder: 'AdministratorsPage.Form.surname.placeholder',
    required: true,
    component: Input,
  },
  email: {
    label: 'auth:SignupForm.Form.email.label',
    name: 'email',
    type: 'email',
    placeholder: 'auth:SignupForm.Form.email.placeholder',
    required: true,
    pattern: {
      value: EMAIL_PATTERN,
      message: 'auth:SignupForm.Form.email.error.invalid',
    },
    component: Input,
  },
  role: {
    label: 'AdministratorsPage.Table.role.label',
    name: 'role',
    type: 'select',
    placeholder: 'AdministratorsPage.Form.role.placeholder',
    required: true,
    options: roleOptions,
    component: SelectController,
  },
  contractIds: {
    label: 'AdministratorsPage.Form.contractsIds.label',
    name: 'contractsIds',
    type: 'select',
    placeholder: 'AdministratorsPage.Form.contractsIds.placeholder',
    multiple: true,
    searchable: false,
    required: true,
    component: ComboboxController,
  },
};
